import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ItemForm from '../../../booking/components/regular_shuttle/ItemForm';
import { bindActionCreators } from 'redux';
import { getRoute, getServiceType } from '../../../../data/booking/selectors/booking';
import { addServiceData, cancel } from '../../../../data/booking/actions/booking';
import { normalizeItem } from '../../../../data/booking/normalizers/regular_shuttle';
import { getDefaultValues } from '../../../../data/booking/selectors/regular_shuttle_form';

class ItemFormContainer extends Component {
    static propTypes = {
        addServiceData: PropTypes.func,
        cancel: PropTypes.func,
        serviceType: PropTypes.string,
        route: PropTypes.object
    };

    handleSubmit(values) {
        return this.props.addServiceData({
            items: [normalizeItem(values)]
        }, true);
    }

    handleClickBack(e) {
        e.preventDefault();
        e.stopPropagation();

        this.props.cancel();
    }

    render() {
        return (
            <ItemForm
                serviceType={this.props.serviceType}
                route={this.props.route}
                onClickBack={::this.handleClickBack}
                initialValues={getDefaultValues()}
                enableReinitialize={true}
                handleSubmit={::this.handleSubmit}
            />
        );
    }
}

export default connect(
    state => ({
        route: getRoute(state.booking),
        serviceType: getServiceType(state.booking)
    }),
    dispatch => bindActionCreators({ addServiceData, cancel }, dispatch)
)(ItemFormContainer);